import { firebase } from '../firebase/firebase';

const sendNoticeFunction = firebase
  .functions()
  .httpsCallable('httpsDashboardSendNotice');

export const sendNotice = (body, subject, clan) => {
  return (dispatch, getState) => {
    const place = getState().place.uid;
    const placeName = getState().place.name;
    return sendNoticeFunction({ body, place, placeName, subject, clan });
  };
};
